import { Mic, MicOff, Video, VideoOff, MonitorUp, MonitorX, LogOut } from "lucide-react";

const btn = "inline-flex items-center gap-2 rounded-full px-4 py-2.5 text-sm font-medium transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-[#144F75]";

export const StudioControls = ({ call, local, onLeave }) => {
  const mic = local?.tracks?.audio?.state === "playable" || local?.audio;
  const cam = local?.tracks?.video?.state === "playable" || local?.video;
  const sharing = local?.tracks?.screenVideo?.state === "playable" || local?.screen;
  const share = () => (sharing ? call?.stopScreenShare() : call?.startScreenShare());
  return (
    <div className="flex flex-wrap gap-2 justify-center" data-testid="studio-controls">
      <button onClick={() => call?.setLocalAudio(!mic)} data-testid="studio-toggle-mic" aria-pressed={!!mic}
        className={`${btn} ${mic ? "bg-white text-[#1A242B] border border-[#E5E0D8]" : "bg-red-600 text-white"}`}>
        {mic ? <Mic size={16} /> : <MicOff size={16} />} {mic ? "Mute" : "Unmute"}
      </button>
      <button onClick={() => call?.setLocalVideo(!cam)} data-testid="studio-toggle-camera" aria-pressed={!!cam}
        className={`${btn} ${cam ? "bg-white text-[#1A242B] border border-[#E5E0D8]" : "bg-red-600 text-white"}`}>
        {cam ? <Video size={16} /> : <VideoOff size={16} />} {cam ? "Camera off" : "Camera on"}
      </button>
      <button onClick={share} data-testid="studio-toggle-screen" aria-pressed={!!sharing}
        className={`${btn} ${sharing ? "bg-[#144F75] text-white" : "bg-white text-[#1A242B] border border-[#E5E0D8]"}`}>
        {sharing ? <MonitorX size={16} /> : <MonitorUp size={16} />} {sharing ? "Stop sharing" : "Share screen"}
      </button>
      <button onClick={onLeave} data-testid="studio-leave" className={`${btn} bg-[#1A242B] text-white hover:bg-black`}>
        <LogOut size={16} /> Leave
      </button>
    </div>
  );
};
